module.exports = __webpack_public_path__ + "static/media/baseline-table_chart-selected-24px.73b2b9d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/baseline-table_chart-selected-24px.svg
// module id = 773
// module chunks = 0